module.exports = __webpack_public_path__ + "static/media/dropdown_arrow.f4ce3591.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/dropdown_arrow.svg
// module id = 142
// module chunks = 0